import React from 'react';
import {Box, Typography} from "@mui/material";
import Link from "next/link";
import IssueItemText from "@/src/components/journal-site/archive/issues/mui-custom/issue-item-text/issue-item-text";
import IssueItemBox from "@/src/components/journal-site/archive/issues/mui-custom/issue-item-box/issue-item-box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleRight, faFileXml} from "@fortawesome/pro-duotone-svg-icons";
import ArchiveIssue from "@/src/_types/archive-issue";

interface IssueProps {
    issue: ArchiveIssue;
}

const IssueItem: React.FC<IssueProps> = ({issue}) => {
    return (
        <Box
            sx={{
                marginY: '.5rem',
            }}
        >
            <IssueItemBox>
                {issue.url ? (
                    <Link
                        style={{
                            textDecoration: 'none'
                        }}
                        href={issue.url ? `/${issue.url}` : '#'}
                    >
                        <IssueItemText>
                            {issue.name?.replace('-', ' ')}
                        </IssueItemText>
                    </Link>
                ) : (
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '1rem',
                    }}>
                        <Link
                            style={{
                                textDecoration: 'none'
                            }}
                            href={issue.issue_link ? `/${issue.issue_link}` : '#'}
                        >
                            <IssueItemText>
                                <Typography component={'span'}>
                                    {`ISSUE ${issue.name?.replace('-', ' ')}`}
                                </Typography>
                                <Typography sx={{
                                    display: {xs: 'none', sm: 'none', md:'inline-block', lg:'inline-block', xl:'inline-block'}
                                }} component={'span'}>
                                    <FontAwesomeIcon icon={faAngleRight} className={'arrow'} />
                                    {issue.published_date}
                                </Typography>
                                <Typography sx={{
                                    display: {xs: 'none', sm: 'none', md:'none', lg:'inline-block', xl:'inline-block'}
                                }} component={'span'}>
                                    <FontAwesomeIcon icon={faAngleRight} className={'arrow'} />
                                    {`${issue.articlesCount} Article(s)`}
                                </Typography>
                            </IssueItemText>
                        </Link>
                        {issue.xml_link && (
                            <Link
                                href={issue.xml_link ? `/${issue.xml_link}` : '#'}
                                style={{
                                    textDecoration: 'none'
                                }}
                            >
                                <IssueItemText>
                                    <FontAwesomeIcon icon={faFileXml} className={'icon'} />
                                </IssueItemText>
                            </Link>
                        )}
                    </Box>
                )}
            </IssueItemBox>
        </Box>
    );
};

export default IssueItem;
